export { jsonpRequest, getQQMapPlaceSuggestions } from './qq-map';
export { default as getStyle } from './get-style';
